import FA from 'admin/components/atoms/FontAwesome';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

type Props = {
  text: string;
  tooltipId?: string;
};

const Icon = styled(FA)`
  cursor: pointer;
  font-size: 12px;
`;

const CopyToClipboardText = styled.b``;

const CopyToClipboard = ({ text, tooltipId = 'copyToClipboard' }: Props) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <Icon
        icon="copy"
        color="#BBBBBB"
        size="2x"
        data-tip
        data-for={tooltipId}
        data-event="click"
      />
      <ReactTooltip
        id={tooltipId}
        type="dark"
        place="bottom"
        effect="solid"
        globalEventOff="click"
        afterShow={copyToClipboard}
      >
        <CopyToClipboardText>クリップボードにコピーしました</CopyToClipboardText>
      </ReactTooltip>
    </>
  );
};

export default styled(CopyToClipboard)``;
